import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=ccb3ef1e"
import script from "./BaseTabs.vue?vue&type=script&lang=js"
export * from "./BaseTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=ccb3ef1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports